import React, { useState, useEffect, use } from 'react';
// Asegúrate de que la ruta de importación sea la correcta para tu proyecto
import rellenarYDescargarCotizacion from './generateTesisCotizacion'; 
import { useDetalleSolicitudModel } from '../../../../modelos/Solicitudes/modeloSolicitud';
import useClientesModel from '../../../../modelos/Clientes/modeloClientes';

const formatearPrecioCOP = (valor) => {
  // Convierte el valor de texto a número. Si no es un número válido, devuelve el texto original.
  const numero = parseFloat(valor);
  if (isNaN(numero)) {
    return valor;
  }

  // Usa la API de Internacionalización para formatear el número
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0, // No mostrar centavos
  }).format(numero);
};

const BotonGenerarCotizacion = ({ solicitud }) => {
    // El manejo del estado y la lógica no cambian en absoluto
    const [modalAbierto, setModalAbierto] = useState(false);
    const [nombreCliente, setNombreCliente] = useState('');
    const [precio, setPrecio] = useState(solicitud.precioCobradoCliente);
    const {actualizarSolicitud} = useDetalleSolicitudModel();
    const {
        cliente,
        getCliente,
        loadingClientes
      } = useClientesModel();

    //cargar cliente
    useEffect(() => {
        if(solicitud.cliente){
            const nombreEmpresa = solicitud.referidoPor != "" ? solicitud.referidoPor : solicitud.nombreEmpresa;
            getCliente(nombreEmpresa, solicitud.cliente);
        }
    }, [solicitud]);

    //cerrar escape
    useEffect(() => {
        // Función que se ejecutará cuando se presione una tecla
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                cerrarModal();
            }
        };

        // Solo añadimos el "listener" si el modal está abierto
        if (modalAbierto) {
            window.addEventListener('keydown', handleKeyDown);
        }

        // Esta es la función de limpieza. Se ejecuta cuando el modal se cierra.
        // Es MUY importante para evitar que el evento se siga escuchando innecesariamente.
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [modalAbierto]);

    const abrirModal = () => {
        setNombreCliente(cliente?.nombrecompletoCliente || '');
        setPrecio(solicitud.precioCobradoCliente);
        setModalAbierto(true);
    };

    const cerrarModal = () => {
        setModalAbierto(false);
        setNombreCliente('');
        setPrecio('');
    };

    const handleGenerarPdf = async() => {
        if (!nombreCliente || !precio) {
            alert('Por favor, ingresa el nombre y el precio.');
            return;
        }

        const datosCotizacion = {
            cliente: nombreCliente,
            precio: `${formatearPrecioCOP(precio)} COP`,
            telefono: solicitud.cliente.toString() ?? '',
            tema: solicitud.objetoFaltante.temaTesis ?? '',
            cotizacionNum: solicitud.id.toString() ?? '',
        };

        await actualizarSolicitud(solicitud.id,solicitud.nombreEmpresa,'precioCobradoCliente',precio,'field');

        rellenarYDescargarCotizacion(datosCotizacion);
        cerrarModal();
    };

    return (
        <>
            {/* Botón principal (puedes mantener tus clases originales) */}
            <button
                onClick={abrirModal}
                 disabled={loadingClientes}
                className="flex-1 bg-blue-600 text-white px-3 py-2 rounded-md hover:bg-blue-700 transition-colors flex items-center justify-center gap-1 text-xs font-medium"
            >
                {loadingClientes ? 'Cargando...' : 'Generar Cotización'}
            </button>

            {/* Diálogo (Modal) con clases de Tailwind CSS */}
            {modalAbierto && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-xl w-11/12 max-w-lg">
                        <h2 className="text-lg font-semibold mb-5">Ingresar Datos para la Cotización</h2>
                        
                        <div className="mb-4">
                            <label className="block mb-1 text-sm font-medium text-gray-700">Nombre del Cliente</label>
                            <input
                                type="text"
                                value={nombreCliente}
                                onChange={(e) => setNombreCliente(e.target.value)}
                                className="w-full p-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Ej: Andrés Durán"
                            />
                        </div>

                        <div className="mb-4">
                            <label className="block mb-1 text-sm font-medium text-gray-700">Precio del Proyecto</label>
                            <input
                                type="text"
                                value={precio}
                                onChange={(e) => setPrecio(e.target.value)}
                                className="w-full p-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Ej: $550.000 COP"
                            />
                        </div>

                        <div className="flex justify-end mt-6">
                            <button 
                                onClick={cerrarModal} 
                                className="py-2 px-4 bg-gray-200 text-gray-800 rounded-md font-semibold text-sm mr-2 hover:bg-gray-300 transition-colors"
                            >
                                Cancelar
                            </button>
                            <button 
                                onClick={handleGenerarPdf} 
                                className="py-2 px-4 bg-blue-600 text-white rounded-md font-semibold text-sm hover:bg-blue-700 transition-colors"
                            >
                                Generar PDF
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default BotonGenerarCotizacion;